const SkillsData = [
  {
    id: 0,
    name: "ReactJs",
    desc: "JavaScript library for building web interfaces.",
    isBackEnd: false,
  },
  {
    id: 1,
    name: "Html",
    desc: "Markup language for web pages.",
    isBackEnd: false,
  },
  {
    id: 2,
    name: "Css",
    desc: "Style sheet language for web page styling.",
    isBackEnd: false,
  },
  {
    id: 3,
    name: "JavaScript",
    desc: "Programming language for web interactivity.",
    isBackEnd: true,
  },
  {
    id: 4,
    name: "Node.js",
    desc: "Runtime environment for server-side JavaScript.",
    isBackEnd: true,
  },
  {
    id: 5,
    name: "API",
    desc: "Interface for software apps to communicate.",
    isBackEnd: true,
  },
  {
    id: 6,
    name: "InDesign",
    desc: "Desktop publishing software.",
    isBackEnd: false,
  },
  {
    id: 7,
    name: "Photoshop",
    desc: "Graphics editing software.",
    isBackEnd: false,
  },
  {
    id: 8,
    name: "Illustrator",
    desc: "Vector graphics editor.",
    isBackEnd: false,
  },
];
export default SkillsData;
